// @ts-check
import { Option } from "./option";
import { Menu } from "./menu";
import { Media } from "./media";
import { User } from "./user";
import { Category } from "./category";
import { Post } from "./post";
import { Admin } from "./admin";
import { th } from "intl-tel-input/i18n";
//import * as bootstrap from 'bootstrap';
export class Dashboard{
/**
 * 
 * @param {any} main 
 * @param {any} state 
 */
constructor(main, state){
this.m = this.main = main;
this.state = state;
this.adminUser = this.main.getCache('user');
this.option = this.main.getCache('option');
this.isTenant = this.adminUser?.topRole == 'ADMIN';

if(state.isInit){
//browser refresh, theme has to be set again
if(this.option){
this.main.setTheme(this.option);
}
}
///
this.child = null;
this.previousChild = null;
this.idsToDelete = [];

document.title = "Dashboard";

this.getTemplate().then(r=>this.init(state));
}//

async getTemplate2(){
let $this = this; 
//let navLinkClasz = ['sp-route-link','sp-admin','nav-link','sp-nav-link','d-flex','align-items-center'];
let navLinkClasz = [...this.m.addRouteClass('admin',true,false,true),'d-flex','align-items-center'];
this.dashboardComponent = this.main.pbu.createElement('main',['dashboard-component']);
this.dashboardComponent.innerHTML = 
`
<main class="dashboard position-relative dashboard-component container-fluid p-0">
<header class="navbar flex-md-nowrap p-0 shadow sticky-top container-fluid sp-bg-primary">
  <a class="navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6 text-white" href="#">${this.adminUser.username}</a>

  <ul class="navbar-nav flex-row d-md-none">
    <li class="nav-item text-nowrap">
      <button class="nav-link px-3 text-white" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSearch" aria-controls="navbarSearch" aria-expanded="false" aria-label="Toggle search">
        <svg class="bi"><use xlink:href="#search"/></svg>
      </button>
    </li>
    <li class="nav-item text-nowrap">
      <button class="nav-link px-3 text-white" type="button" data-bs-toggle="offcanvas" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
        <svg class="bi"><use xlink:href="#list"/></svg>
      </button>
    </li>
  </ul>

  <div id="navbarSearch" class="navbar-search w-100 collapse">
    <input class="form-control w-100 rounded-0 border-0" type="text" placeholder="Search" aria-label="Search">
</header>

<div class="container-fluid">
<div class="row">
<div class="sidebar dashboard-sidebar border border-right col-md-1 col-lg-1 p-0 bg-body-tertiary">
<div class="offcanvas-md offcanvas-end bg-body-tertiary" tabindex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel">
<div class="offcanvas-header">
<h5 class="offcanvas-title" id="sidebarMenuLabel">${this.adminUser.username}</h5>
<button type="button" class="btn-close" data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu" aria-label="Close"></button>
</div>
<div class="offcanvas-body d-md-flex flex-column p-0 pt-lg-3 overflow-y-auto">
<ul class="nav flex-column sp-admin-menu">

</ul>

<ul class="nav flex-column mb-auto">
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Dashboard',[{n:'type',v:'button'},{n:'href',v:'/app/dashboard/page/detail/0'},{n:'ic',v:'speedometer2'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Settings',[{n:'type',v:'button'},{n:'href',v:'/app/option/page/edit/0'},{n:'ic',v:'gear'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Menu',[{n:'type',v:'button'},{n:'href',v:'/app/menu/page/list/0'},{n:'ic',v:'list'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Users',[{n:'type',v:'button'},{n:'href',v:'/app/user/page/list/0'},{n:'ic',v:'person'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Media',[{n:'type',v:'button'},{n:'href',v:'/app/media/media/list/0'},{n:'ic',v:'image'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Pages',[{n:'type',v:'button'},{n:'href',v:'/app/post/page/list/0'},{n:'ic',v:'file-text'}]])}


<li class="nav-item dropdown">
<a type="button" class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
${await this.main.pbu.getSvg('file-post')}Posts</a>
<ul class="dropdown-menu">

<li><a type="button" href="/app/post/post/list/0" class="dropdown-item ${this.m.addRouteClass('admin',true,false)}">
${await this.main.pbu.getSvg('file-post')}
All Posts</a></li>


<li><a type="button" href="/app/category/post/list/0" class="dropdown-item ${this.m.addRouteClass('admin',true,false)}">
${await this.main.pbu.getSvg('tag')}
Categories</a></li>
</ul>
</li>

<hr class="my-3">
${await this.m.pbu.ce(['li',['nav-item']],['a',['sp-administration','sp-route-link','sp-admin','nav-link','sp-nav-link','d-flex','align-items-center'],'Admin',[{n:'type',v:'button'},{n:'ic',v:'person-gear'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',['sp-signout','sp-route-link','sp-admin','nav-link','sp-nav-link','d-flex','align-items-center'],'Sign out',[{n:'type',v:'button'},{n:'ic',v:'box-arrow-right'}]])}
</ul>
</div>
</div>
</div>

<main class="col-md-11 ms-sm-auto col-lg-11 px-md-4">
<div class="sp-tenant-header d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h3 sp-component-title">Dashboard</h1>
        
        <div class="btn-toolbar mb-2 mb-md-0">
          <div class="btn-group me-2 sp-new">
    
          </div>
          <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle d-flex align-items-center gap-1">
            <svg class="bi"><use xlink:href="#calendar3"/></svg>
            This week
          </button>
        </div>
      </div>

<div id="dashboardReplace">
</div>
</main>

</div>
</div>
</div>

<section id="promptModalSection"></section>
<section id="offCanvasSection"></section>

<footer class="sp-dashboard-footer container-fluid sticky-bottom bg-light flex justify-content-around">
<div class="row">
<div class="sp-post-preview col-md-10"></div>
<div class="sp-save-button  col-md-1 col-12"></div>
</div>

</footer>
</main>
`;
this.offCanvasSidebar = this.dashboardComponent.querySelector('div#sidebarMenu');
this.componentTitle = this.dashboardComponent.querySelector('h1.sp-component-title');
this.spNew = this.dashboardComponent.querySelector('div.sp-new');
this.dashboardReplace =  this.dashboardComponent.querySelector('#dashboardReplace');
this.profileLink = this.dashboardComponent.querySelector('a.sp-profile-link');
this.signoutLink = this.dashboardComponent.querySelector('a.sp-signout');
this.adminMenu = this.dashboardComponent.querySelector('ul.sp-admin-menu'); 
this.footer = this.dashboardComponent.querySelector('footer.sp-dashboard-footer');
this.postPreviewDiv = this.dashboardComponent.querySelector('div.sp-post-preview');
this.saveButtonDiv = this.dashboardComponent.querySelector('div.sp-save-button');
this.mount(null);
///
addEvents();
//finally
async function addEvents(){
//close offcanvas menu
let offcanvas = bootstrap.Offcanvas.getOrCreateInstance($this.offCanvasSidebar);
$this.offCanvasSidebar.querySelectorAll('.nav-link').forEach(link => {
  link.addEventListener('click', () => {
    offcanvas.hide();
  });
});

let dropDown = await $this.main.pbu.getDropdown({name:'New',color:'primary',items:['Post','Page','Category','Menu','User','Media'],cb:async (value)=>{
let postType,component;
switch(value){
  case 'post':
    component = 'post';
    postType = 'post';
    break;
  case 'page':
    component = 'post';
    postType = 'page';
    break;
  case 'category':
    component = 'category';
    postType = 'post';
    break;
  default:
    component = value;
    postType = 'page';
    break;
}
let link = $this.m.getLink(component,postType,'new',-1);
$this.m.handleAdmin(link,false);
}});
$this.m.pbu.replace($this.spNew,dropDown);

$this.main.addRouteEvents($this.dashboardComponent); 
$this.main.pbu.listen($this.signoutLink,'click',async(e)=>{
e.preventDefault();
let r = await $this.main.fu.fetch({link:$this.main.fu.getApi('/app/logout'),method:'POST',isAdmin:true});
if(r==true){
localStorage.clear();
$this.main.navigate($this.main.getLoginState($this.state.username,false));
window.location.reload();
}
});

//admin
$this.administrationLink = $this.dashboardComponent.querySelector('a.sp-administration');
$this.m.pbu.listen($this.administrationLink,'click',async()=>{
let adminComponent = new Admin($this.m);
adminComponent.getTemplate().then(r=>$this.m.pbu.replace($this.dashboardReplace,r));
;
});
}//inner
}//func


async getTemplate(){
let $this = this; 
//let navLinkClasz = ['sp-route-link','sp-admin','nav-link','sp-nav-link','d-flex','align-items-center'];
let navLinkClasz = [...this.m.addRouteClass('admin',true,false,true),'d-flex','align-items-center'];
this.dashboardComponent = this.main.pbu.createElement('main',['dashboard-component']);
this.dashboardComponent.innerHTML = 
`
<main class="dashboard position-relative dashboard-component container-fluid p-0">
<header class="navbar flex-md-nowrap p-0 shadow sticky-top container-fluid sp-bg-primary">
  <a class="navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6 text-white" href="#">${this.adminUser.username}</a>

  <ul class="navbar-nav flex-row d-md-none">
    <li class="nav-item text-nowrap">
      <button class="nav-link px-3 text-white" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSearch" aria-controls="navbarSearch" aria-expanded="false" aria-label="Toggle search">
        <svg class="bi"><use xlink:href="#search"/></svg>
      </button>
    </li>
    <li class="nav-item text-nowrap">
      <button class="nav-link px-3 text-white" type="button" data-bs-toggle="offcanvas" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
        <svg class="bi"><use xlink:href="#list"/></svg>
      </button>
    </li>
  </ul>

  <div id="navbarSearch" class="navbar-search w-100 collapse">
    <input class="form-control w-100 rounded-0 border-0" type="text" placeholder="Search" aria-label="Search">
</header>

<div class="container-fluid">
<div class="row">
<div class="sidebar dashboard-sidebar border border-right col-md-1 col-lg-1 p-0 bg-body-tertiary">
<div class="offcanvas-md offcanvas-end bg-body-tertiary" tabindex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel">
<div class="offcanvas-header">
<h5 class="offcanvas-title" id="sidebarMenuLabel">${this.adminUser.username}</h5>
<button type="button" class="btn-close" data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu" aria-label="Close"></button>
</div>
<div class="offcanvas-body d-md-flex flex-column p-0 pt-lg-3 overflow-y-auto">
<ul class="nav flex-column sp-admin-menu">

</ul>

<ul class="nav flex-column mb-auto">
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Dashboard',[{n:'type',v:'button'},{n:'href',v:'/app/dashboard/page/detail/0'},{n:'ic',v:'speedometer2'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Settings',[{n:'type',v:'button'},{n:'href',v:'/app/option/page/edit/0'},{n:'ic',v:'gear'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Menu',[{n:'type',v:'button'},{n:'href',v:'/app/menu/page/list/0'},{n:'ic',v:'list'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Users',[{n:'type',v:'button'},{n:'href',v:'/app/user/page/list/0'},{n:'ic',v:'person'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Media',[{n:'type',v:'button'},{n:'href',v:'/app/media/media/list/0'},{n:'ic',v:'image'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Pages',[{n:'type',v:'button'},{n:'href',v:'/app/post/page/list/0'},{n:'ic',v:'file-text'}]])}

<li class="nav-item dropdown">
<a type="button" class="dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
${await this.main.pbu.getSvg('file-post')}Posts</a>
<ul class="dropdown-menu">
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'All Posts',[{n:'type',v:'button'},{n:'href',v:'/app/post/post/list/0'},{n:'ic',v:'file-post'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',navLinkClasz,'Categories',[{n:'type',v:'button'},{n:'href',v:'/app/category/post/list/0'},{n:'ic',v:'tag'}]])}
</ul>
</li>

<hr class="my-3">
${await this.m.pbu.ce(['li',['nav-item']],['a',['sp-administration','sp-route-link','sp-admin','nav-link','sp-nav-link','d-flex','align-items-center'],'Admin',[{n:'type',v:'button'},{n:'ic',v:'person-gear'}]])}
${await this.m.pbu.ce(['li',['nav-item']],['a',['sp-signout','sp-route-link','sp-admin','nav-link','sp-nav-link','d-flex','align-items-center'],'Sign out',[{n:'type',v:'button'},{n:'ic',v:'box-arrow-right'}]])}
</ul>
</div>
</div>
</div>

<main class="col-md-11 ms-sm-auto col-lg-11 px-md-4">
<div class="sp-tenant-header d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h3 sp-component-title">Dashboard</h1>
        
        <div class="btn-toolbar mb-2 mb-md-0">
          <div class="btn-group me-2 sp-new">
    
          </div>
          <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle d-flex align-items-center gap-1">
            <svg class="bi"><use xlink:href="#calendar3"/></svg>
            This week
          </button>
        </div>
      </div>

<div id="dashboardReplace">
</div>
</main>

</div>
</div>
</div>

<section id="promptModalSection"></section>
<section id="offCanvasSection"></section>

<footer class="sp-dashboard-footer container-fluid sticky-bottom bg-light flex justify-content-around">
<div class="row">
<div class="sp-post-preview col-md-10"></div>
<div class="sp-save-button  col-md-1 col-12"></div>
</div>

</footer>
</main>
`;
this.offCanvasSidebar = this.dashboardComponent.querySelector('div#sidebarMenu');
this.componentTitle = this.dashboardComponent.querySelector('h1.sp-component-title');
this.spNew = this.dashboardComponent.querySelector('div.sp-new');
this.dashboardReplace =  this.dashboardComponent.querySelector('#dashboardReplace');
this.profileLink = this.dashboardComponent.querySelector('a.sp-profile-link');
this.signoutLink = this.dashboardComponent.querySelector('a.sp-signout');
this.adminMenu = this.dashboardComponent.querySelector('ul.sp-admin-menu'); 
this.footer = this.dashboardComponent.querySelector('footer.sp-dashboard-footer');
this.postPreviewDiv = this.dashboardComponent.querySelector('div.sp-post-preview');
this.saveButtonDiv = this.dashboardComponent.querySelector('div.sp-save-button');
this.mount(null);
///
addEvents();
//finally
async function addEvents(){
//close offcanvas menu
let offcanvas = $this.m.bootstrap.Offcanvas.getOrCreateInstance($this.offCanvasSidebar);
$this.offCanvasSidebar.querySelectorAll('.nav-link').forEach(link => {
  link.addEventListener('click', () => {
    offcanvas.hide();
  });
});

let dropDown = await $this.main.pbu.getDropdown({name:'New',color:'primary',items:['Post','Page','Category','Menu','User','Media'],cb:async (value)=>{
let postType,component;
switch(value){
  case 'post':
    component = 'post';
    postType = 'post';
    break;
  case 'page':
    component = 'post';
    postType = 'page';
    break;
  case 'category':
    component = 'category';
    postType = 'post';
    break;
  default:
    component = value;
    postType = 'page';
    break;
}
let link = $this.m.getLink(component,postType,'new',-1);
$this.m.handleAdmin(link,false);
}});
$this.m.pbu.replace($this.spNew,dropDown);

$this.main.addRouteEvents($this.dashboardComponent); 
$this.main.pbu.listen($this.signoutLink,'click',async(e)=>{
e.preventDefault();
let r = await $this.main.fu.fetch({link:$this.main.fu.getApi('/app/logout'),method:'POST',isAdmin:true});
if(r==true){
localStorage.clear();
$this.main.navigate($this.main.getLoginState($this.state.username,false));
window.location.reload();
}
});

//admin
$this.administrationLink = $this.dashboardComponent.querySelector('a.sp-administration');
$this.m.pbu.listen($this.administrationLink,'click',async()=>{
let adminComponent = new Admin($this.m);
adminComponent.getTemplate().then(r=>{
  $this.m.pbu.replace($this.dashboardReplace,r)
  $this.saveButtonDiv.innerHTML = '';
}
  
);
;
});
}//inner
}//func


/**
 * 
 * @param {any} state 
 */
async init(state){
this.componentTitle.textContent = `${this.main.utils.capitalize(state.component)} - ${this.adminUser.topRole}`;
//this.profileLink.textContent = this.main.host;
}


/**
 * 
 * @param {HTMLElement} component 
 */
addRouteEvents(component){
this.main.addRouteEvents(component);
//MASS ACTION
this.tb = this.main.pbu.query('tbody.mass-action');
if(this.tb){
let deleteLinks = this.tb.querySelectorAll('a.sp-delete[data-id]');
for(let l of deleteLinks){
this.main.pbu.listen(l,'click',async ()=>{
await this.deleteItems([Number(l.getAttribute('data-id'))]);
});
}
}//if
}//func

/**
 * 
 * @param {any|null} state 
 */
async mount(state){
//remove previous save button

if(!state){
//Note: no state = mounting dashboard initially
this.replace = this.main.pbu.query('#replace');
this.main.pbu.replace(this.replace,this.dashboardComponent);
}else{
let template = await this.process(state);
this.main.pbu.replace(this.dashboardReplace,template);
this.saveButtonDiv.innerHTML = '';
if((state.type=='new'||state.type=='edit') && ['option','post','page','category','menu','user'].includes(state.component)){
this.m.pbu.getEventButton('Save',{cb:()=>{
if(state.component=='post'){
this.child.pb.save();
}else{
this.child.save();
}
},clasz:['w-100','w-md-auto']}).then(b=>this.m.pbu.replace(this.saveButtonDiv,b,true));
}
this.addRouteEvents(template);
this.init(state);
}
}//func


/**
 * 
 * @param {any} child 
 * @param {any} state
 */
setChild(child,state){
//finalize previous 
this.previousChild = this.child;
this.main.finalize(this.previousChild);
this.child = child;
this.child.state = state;//important, otherwise old state of object will be used when reusing object
this.child.parent = this;
}//func

/**
 * 
 * @param {any} state 
 * @returns 
 */

async process(state){
if(! state.stateObject){
//leave complete state here, it enables 
//state has url when created, its converted to link before fetching
state.link = this.main.fu.getApi(state.url);
state.stateObject = await this.main.fu.fetch(this.main.utils.clone(state));
}
this.main.log(state.stateObject,`${this.state.component}.process(): stateObject`);
switch(state.component){
case 'option':
//avoid conflict with class member
let option = new Option(this.main,state);
this.setChild(option,state);
break;
/// ########## MENU ##############
case 'menu':
this.menu = new Menu(this.main,state);
this.setChild(this.menu,state);
break;
case 'media':
this.media = new Media(this.main,state);
this.setChild(this.media,state);
break;
case 'user':
/// ########## USER ##############
this.user = new User(this.main,state);
this.setChild(this.user,state);
break;
/// ########## CATEGORY ##############
case 'category':
this.category = new Category(this.main,state);
this.setChild(this.category,state);
break;
/// ########## POST ##############
case 'post':
this.post=  new Post(this.main,state);
this.setChild(this.post,state);
break;
}//switch
//finally
if(state.type=='list'){
return await this.child.getListTemplate();
}else if(state.type=='new' || state.type=='edit'){
return await this.child.getFormTemplate();
}else{
return await this.child.getTemplate();
}
}//func

/**
 * 
 * @param {number[]} ids 
 */
async deleteItems(ids){
if(ids?.length==0){return;}
this.m.modal = this.m.utils.setModal('Confirm Deletion','blanc',this.main.isView,{cb:async()=>{
this.m.modal.close();
let updatedItems =[];
let items = this.child.getItems();
for(let i of items){
if (ids.includes(i.id)){
continue;
}else{
updatedItems.push(i);
}
}//for
//
//for delete, child state url must be explicely specify
//otherwise, backend will see componet as dashboard 
let r = await this.main.fu.fetch({
link:this.main.fu.getApi(this.child.state.url),
body:JSON.stringify(ids),
method:"DELETE"
});
if(r==true){
this.child.setItems(updatedItems);
//note: media component doesnt use same table 
let entries = this.dashboardComponent.querySelectorAll('.mass-action-entry');
for(let entry of entries){
if(ids.includes(Number(entry.getAttribute('data-id')))){
entry.remove();
}
}
this.m.utils.notify('Deleted',{level:0});
//this.m.modal.close();
this.footer.querySelector('button.trash')?.remove();
}
}});

}//

/**
 * 
 * @param {HTMLInputElement} input 
 */
async showTrashButton(input){
this.main.pbu.listen(input,'change',async()=>{
//NOTE: parent is dashboard
let container = input.closest('.mass-action');
let trashButton = this.footer.querySelector('button.trash');
if(input.checked){
if(!trashButton){
trashButton = await this.main.pbu.getEventButton('Trash',{size:'sm',clasz:['trash'],icon:'trash',cb:()=>{
let mediaIds = [];
let inputs = [...container.querySelectorAll('input')].filter(i=>i.checked);
for(let input of inputs){
mediaIds.push(Number(input.getAttribute('data-id')));
}
this.main.log(mediaIds);
this.deleteItems(mediaIds);
}});
this.main.pbu.prependChild(this.footer,trashButton);
}
}else{
let inputs = [...container.querySelectorAll('input')].filter(i=>i.checked);
if(inputs.length==0){
trashButton?.remove();
}
}

});
}//func
}//#class
